import {HTMLPrinter} from "./htmlprinter";
import {getDialog} from "./dialogDefinitions";
import {setGlobalVar} from "./globalUtils";
import {EventVerteiler} from "./eventVerteiler";

export const POPUPS ={
    FEATURES : '#open-popup-produktauswahl-features',
    PRODUKTAUSWAHL : '#open-popup-produktauswahl',
    PRODUKTKATEGORIENAUSWAHL : '#open-popup-produktauswahl-summary',
    EINZELEXEMPLAR_ERKLAERUNG :  '#einzelExemplarErklaerung',
    EXPRESS_ANFRAGE : '#open-expressanfrage-popup-formular',
    HELP_FORMULAR : '#open-popup-formular',
    PREIS_UEBERSICHT : '#open-popup-preisuebersicht',
    PREISINEURO : '#open-popup-preisInEuro',
    CHANGE_KONTAKTDATEN : '#open-popup-changeKontaktdaten',
    BENUTZERDATEN : "#open-popup-loginAnmeldung",
    REGISTRATION: "#open-popup-loginRegistrierung",
    ANZAHL_EINZELEXEMPLARE_CHANGED : '#open-popup-AnzahlExemplareChanged',
    ANZAHL_EINZELEXEMPLARE : "#open-popup-AnzahlExemplare",
    EXEMPLAR_DATEN : "#open-popup-Exemplardaten",
    LIEFERZEIT : '#open-popup-lieferzeit',
    LOGO_CONVERSION : '#open-popup-logoConversion',
    TEXT_CHANGE : '#open-popup-textChange',
    BG_REMOVAL_RESULT : '#open-popup-bg-removal-result',
    BG_REMOVAL : '#open-popup-logo-bg-removal',
    CONFIRM_DELETE: "#open-popup-confirm-delete"

};

export enum PopupNames {
    "FEATURES",
"PRODUKTAUSWAHL",
"PRODUKTKATEGORIENAUSWAHL",
"EINZELEXEMPLAR_ERKLAERUNG",
"EXPRESS_ANFRAGE",
"HELP_FORMULAR",
"PREIS_UEBERSICHT",
"CHANGE_KONTAKTDATEN",
"BENUTZERDATEN",
"REGISTRATION",
"ANZAHL_EINZELEXEMPLARE_CHANGED",
"ANZAHL_EINZELEXEMPLARE",
"EXEMPLAR_DATEN",
"LIEFERZEIT",
"LOGO_CONVERSION",
"TEXT_CHANGE",
"BG_REMOVAL_RESULT",
"BG_REMOVAL",
"CONFIRM_DELETE",
}

export class PopupButton {
    public text: string;

    public closeAfter: boolean;
    public callback: (()=>void) | null;
    public color: string;

    public constructor(text, callback:(()=>void)|null = null, color="blue", closeAfter = true) {
        this.text = text;
        this.closeAfter = closeAfter;
        this.callback = callback;
        this.color = color;
    }
}

export class PopupButtonUntranslated extends PopupButton {
    public textUntranslated!:{id, alternative}

}

export class PopupTools {
    private static popupOpen = false;
    private static formerParentOfContent = null as null|JQuery<HTMLElement>
    public static translate:(id:string, fallback?:string)=>string;
    public static trackPageview:(page:string)=>void


    public static init(translate:(id, fallback?)=>string, trackPageView:(page:string)=>void) {
        PopupTools.translate = translate
        PopupTools.trackPageview = trackPageView;
    }

    public static openPopup(src, closeButtonInside = true, closeObBGClick = false) {
        const popupContainer = $("#popup_container");
        if(PopupTools.popupOpen) {
            PopupTools.close();
        }
        const $src = $(src);
        PopupTools.formerParentOfContent = $src.parent();
        $($src).detach().appendTo(popupContainer);

        $src.removeClass("mfp-hide");
        popupContainer.removeClass("mfp-hide");
        $(".mfp-bg").removeClass("mfp-hide");
        if(closeButtonInside) {
            PopupTools.insertCloseButton(src);
        }
        PopupTools.popupOpen = true;
        $(src).find(".close, .mfp-close").off().click(()=>PopupTools.close());
        if(closeObBGClick) {
            PopupTools.addOutsideClickHandler();
        }
    }

    private static isClickOutside = event=> {
        const popup = document.querySelector("#popup_container")
        if (!(popup === event.target || popup.contains(event.target))) {
            // and if it did, call method provided in attribute value
            PopupTools.close();
        }
    }

    private static addOutsideClickHandler() {
        document.body.addEventListener("click", PopupTools.isClickOutside)
    }

    private static removeOutsideClickHandler() {
        document.body.removeEventListener("click", PopupTools.isClickOutside);
    }

    private static insertCloseButton(src) {
        $(src).prepend('<button title="close" type="button" class="mfp-close insertedbypopuptools">&#215;</button>');

    }

    public static close() {
        const popupContainer = $("#popup_container");
        popupContainer.find(".insertedbypopuptools").remove();
        popupContainer.children().detach().appendTo(PopupTools.formerParentOfContent).addClass("mfp-hide");
        PopupTools.formerParentOfContent = null;
        PopupTools.popupOpen = false;
        EventVerteiler.broadcast("popupClosedEvent");
        popupContainer.addClass("mfp-hide");
        $(".mfp-bg").addClass("mfp-hide");
        $(".ui-tooltip").remove();
        PopupTools.removeOutsideClickHandler();
    }

    public static openConfirmDeletePopup = (messageID, callback)=> {
        PopupTools.openPopup(POPUPS.CONFIRM_DELETE);
        $(POPUPS.CONFIRM_DELETE + " h2").text(PopupTools.translate(messageID));
        $("#confirmDelete").off().click(callback);
    }

    public static openFeaturesPopup = ()=>PopupTools.openPopup(POPUPS.FEATURES, true);
    public static openHowToEinzelexemplarDialog = ()=>PopupTools.openPopup(POPUPS.EINZELEXEMPLAR_ERKLAERUNG);
    public static openExpressanfrageFormular = ()=>PopupTools.openPopup(POPUPS.EXPRESS_ANFRAGE);
    public static openGetHelpFormular = ()=>PopupTools.openPopup(POPUPS.HELP_FORMULAR, true);
    public static openChangeKontaktdaten = ()=>PopupTools.openPopup(POPUPS.CHANGE_KONTAKTDATEN);

    public static openBenutzerdatenPopupMitVorbelegung = (iframeViewController)=>iframeViewController.openUserManagement("login", "username");
    public static openAnzahlExemplarePopup = ()=>PopupTools.openPopup(POPUPS.ANZAHL_EINZELEXEMPLARE);
    public static getOKButton = ()=>[new PopupButton(PopupTools.translate("konf_OK", "OK"))];
    public static openEntwuerfeFenster = ()=>PopupTools.openPopup('#open-popup-meineEntwuerfe');

    public static openProduktKategorienauswahlPopup() {
        PopupTools.trackPageview("konfitrack-produktwechsel.htm");
        EventVerteiler.broadcast("openPopupEvent", PopupNames.PRODUKTKATEGORIENAUSWAHL)
    }

    public static fillUserInteractionPopupButtons(container, buttons) {
        const p = HTMLPrinter;
        $("ul", container).empty();
        const floatDirections = PopupTools.getFloatDirections(buttons);

        if(buttons.length ===1) {
            $(".popup-footer-btn", container).addClass("single-button");
        } else {
            $(".popup-footer-btn", container).removeClass("single-button");
        }

        function makeCloseHandler() {
            $(".mfp-close", container).off().click(function() {
                EventVerteiler.broadcast("popupClosedEvent");
                container.css("display", "none");
            })
        }

        function makeClickhandler(buttonElement, callback, closeAfter) {
            buttonElement.click(function (event) {
                if (typeof (callback) === "function") {
                    callback(event);
                }
                if (closeAfter !== false) {
                    container.css("display", "none");
                }
            });
        }

        buttons.forEach(function(button, index) {
            const id = "userInteractionButton" + index;
            const direction = typeof(floatDirections[index]) === "undefined" ? "" : floatDirections[index];
            const buttonHTML = PopupTools.getButton(id, button.text, button.color, direction);
            $("ul", container).append(p.li(buttonHTML));
            makeClickhandler($("#"+id), button.callback, button.closeAfter);
        });

        makeCloseHandler();
    }

    private static getFloatDirections(buttons) {
        switch(buttons.length) {
            case 1:
                return ["center"];
            case 2:
                return ["left", "right"];
            default:
                return [];
        }
    }

    public static displayDialogEventHandler(container, messageDialog, messageAddition="", callbacks=[]) {
        const dialog = PopupTools.constructDialogboxDataObject(messageDialog, messageAddition, callbacks) as {title, message, buttons, cssClass};
        PopupTools.displayUserInteractionDialog(container, dialog.cssClass, dialog.title, dialog.message, dialog.buttons);
    }


    public static constructDialogboxDataObject(dialog, messageAddition, callbacks) {
        const output = getDialog(dialog);
        if (typeof (output) === "undefined") {
            return null;
        }
        if (typeof (messageAddition) === "undefined") {
            messageAddition = "";
        }
        output.title = PopupTools.translate(output.titleUntranslated.id, output.titleUntranslated.alternative);
        output.message = PopupTools.getDialogMessage(output.messageUntranslated, messageAddition);
        output.buttons.forEach(
            function(button, index) {
                button.text =PopupTools.translate(button.textUntranslated.id, button.textUntranslated.alternative)
                if(typeof (callbacks[index]) === "function" ) {
                    button.callback = callbacks[index];
                }
            }
        );
        return output;
    }

    private static getDialogMessage(messageObjectOrArray, messageAddition) {
        const p = HTMLPrinter;
        if(Array.isArray(messageObjectOrArray)) {
            return p.sentence(
                messageObjectOrArray.map(
                    function (messageObject) {
                        return p.p(PopupTools.translate(messageObject.id, messageObject.alternative));
                    }
                ).join("\n"),
                messageAddition
            ).trim();
        }
        if(messageObjectOrArray.id === "") {
            return messageAddition;
        }
        return p.sentence(
            PopupTools.translate(messageObjectOrArray.id, messageObjectOrArray.alternative),
            messageAddition
        ).trim();
    }

    public static displayUserInteractionDialog(container, cssClass, title, message, buttons:PopupButton[]|null =null) {
        if(buttons === null) {
            buttons = PopupTools.getOKButton();
        }
        container.attr("class", "white-popup " + cssClass);
        $("header", container).html(HTMLPrinter.h2(title));
        $("section", container).html(HTMLPrinter.p(message));
        PopupTools.fillUserInteractionPopupButtons(container, buttons);

        container.css("display", "block");
    }

    public static getButton(id, text, color="blue", floatdirection="") {
        const p = HTMLPrinter;
        return p.a(
            p.id(id),
            p.emptyhref,
            p.cssClass(
                p.prepend("standard-btn-", color),
                "close",
                floatdirection !== "" ? p.prepend(floatdirection, "-btn") : "",
                "button"
            )
        )(text);
    }
}

setGlobalVar("PopupTools", PopupTools);
